import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  z-index: 10;
  top: 0;
  left: 0;
  display: ${({ isModalOpen }) => !isModalOpen && 'none'};
  background: hsl(0, 0%, 60%, 0.7);
`;

const Modal = styled.div`
  padding: 1rem;
  height: 350px;
  width: 350px;
  background: white;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  background-color: white;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  h3 {
    font-weight: bold;
    padding: 0.5rem;
    font-size: 1.25rem;
  }
`;

const Socials = styled.div`
  display: flex;
  flex-wrap: wrap;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 140px;
    div {
      height: 56px;
      width: 56px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      border-radius: 20px;
    }
    p {
      margin-top: 0.5rem;
    }
  }
`;

export { Modal, Header, Socials };

export default Container;
